import React, { Component } from 'react'
import { Drawer, TextField } from '@mui/material'
import { isMobile } from 'react-device-detect'


function CoachingEntryDrawer(props) {
  const { open, onClose, entry, application } = props
  return (
    <Drawer
      anchor={isMobile ? 'bottom' : 'right'}
      open={open}
      onClose={onClose}
    >
      <div style={{ width: isMobile ? '100%' : 400, padding: 20 }}>
        <h2>Coaching Entry Details</h2>
        {entry ? (
          <div>
            <p><strong>Name:</strong> {entry.name}</p>
            <p><strong>Email:</strong> {entry.email}</p>
            <p><strong>Phone:</strong> {entry.phone}</p>
            <p><strong>Application:</strong> {application ? application.name : 'N/A'}</p>
            <p><strong>Season:</strong> {entry.season}</p>
            <p><strong>Class:</strong> {entry.class}</p>
          </div>
        ) : (
          <p>No entry selected.</p>
        )}
      </div>
    </Drawer>
  )
}

export default CoachingEntryDrawer